import apiFetch from '../apiFetch'

export default function (saleId, token) {
  return apiFetch({ endPoint: `Dossier/Sale/RemoveReactivatedFinancing/${saleId}`, method: 'DELETE', token: token })
}
